// extracted by mini-css-extract-plugin
export default {"Container":"EmailAndContact_Container__p++vr"};